module.exports = __webpack_public_path__ + "img/geometry wars icon.44ae2285.png";